module.exports = __webpack_public_path__ + "media/images/vacances-ete-m-d5c0e95b2a3756123620f86ab7a1f442.jpg";